module.exports = __webpack_public_path__ + "img/hd-menu-icon.bec5bfe3.svg";